import { readBagsAnalytic } from './bagsAnalyticSchemes';
import { readFacecoverAnalytic } from './facecoverAnalyticSchemes';
import { readFallAnalytic } from './fallAnalyticSchemes';
import { readFightAnalytic } from './fightAnalyticSchemes';
import { readFireAnalytic } from './fireAnalyticSchemes';
import { readHandsupAnalytic } from './handsupAnalyticSchemes';
import { readLyingAnalytic } from './lyingAnalyticSchemes';
import { readPeopleCountAnalytic } from './peopleCountAnalyticSchemes';
import { readWeaponAnalytic } from './weaponAnalyticSchemes';
import { CAMERA_ROTATION_OPTIONS, STREAM_DATA_TYPE_OPTIONS, TIMESTAMP_SOURCE_OPTIONS } from '../../../constants';
import { get, CleanSchema } from '../../../json-transform';

const readAnalyticsMap = {
  people_count: readPeopleCountAnalytic,
  weapon_analytics: readWeaponAnalytic,
  fights_analytics: readFightAnalytic,
  fire_analytics: readFireAnalytic,
  facecover_analytics: readFacecoverAnalytic,
  bags_analytics: readBagsAnalytic,
  lying_analytics: readLyingAnalytic,
  handsup_analytics: readHandsupAnalytic,
  fall_analytics: readFallAnalytic,
};
const readAutorestartScheme = (analyticsArr) => {
  // поля для autorestart берутся из первого значения в массиве ВА, т.к. для всех аналитик они одинаковые
  const autorestart = analyticsArr?.find((analytic) => analytic?.autorestart)?.autorestart;

  if (!autorestart) return undefined;

  return {
    restart: Boolean(autorestart.restart),
    attempt_count: autorestart.attempt_count,
    delay: autorestart.delay,
  };
};

export const read = new CleanSchema({
  name: get('name'),
  description: get('description'),
  status: get('status'),
  groups: get('groups'),
  splittable: get('splittable'),
  data: {
    downloadable: get('data.downloadable').asBoolean(),
    type: get('data.type').asOption(STREAM_DATA_TYPE_OPTIONS),
    reference: get('data.reference'),
    rotation: get('data.rotation').asOption(CAMERA_ROTATION_OPTIONS),
    timestamp_source: get('data.timestamp_source').asOption(TIMESTAMP_SOURCE_OPTIONS),
    pts: {
      start_time: get('data.pts.start_time'),
    },
  },
  location: {
    city: get('location.city'),
    area: get('location.area'),
    district: get('location.district'),
    street: get('location.street'),
    house_number: get('location.house_number'),
    geo_position: {
      longitude: get('location.geo_position.longitude'),
      latitude: get('location.geo_position.latitude'),
    },
  },
  autorestart: get('analytics').as(readAutorestartScheme),
  analytics: get('analytics').asArrayOf((analytic) => readAnalyticsMap[analytic.analytic_name](analytic)),
});
